<template>
  <div class="forgot-page">
    <h2>Forgot Password</h2>

    <form @submit.prevent="sendResetLink">

      <div>
        <input
          type="email"
          v-model="email"
          placeholder="Enter your email"
          required
        />
      </div>

      <button type="submit">
        Enviar enlace de reinicio
      </button>

    </form>

    <p>
      <router-link to="/login">
        Volver a iniciar sesión
      </router-link>
    </p>

  </div>
</template>

<script>

import {HTTP} from '../../_helper/http-constants.js';

export default {
  name: "ForgotPassword",

  data() {
    return {
      email: ""
    };
  },

  methods: {

    async sendResetLink() {
      try {

        await HTTP.post("/auth/forgot-password", {
          email: this.email
        });

        alert("Se ha enviado un enlace de restablecimiento a su correo electrónico.");

      } catch (error) {

        alert(
          error.response?.data?.message ||
          "Error al enviar el enlace de reinicio"
        );

      }
    }

  }
};
</script>